import _objectSpread from '@babel/runtime/helpers/objectSpread2';
import { tokens } from '@equinor/eds-tokens';

var typography = tokens.typography,
  colorsToken = tokens.colors,
  focusOutlineWidth = tokens.interactions.focused.width;
var heading = typography.heading,
  paragraph = typography.paragraph;
var _colorsToken$interact = colorsToken.interactive,
  primary = _colorsToken$interact.primary__resting.rgba,
  secondary = _colorsToken$interact.secondary__resting.rgba,
  danger = _colorsToken$interact.danger__resting.rgba,
  warning = _colorsToken$interact.warning__resting.rgba,
  success = _colorsToken$interact.success__resting.rgba,
  disabled = _colorsToken$interact.disabled__text.rgba,
  focus = _colorsToken$interact.focus.rgba;
var colors = {
  primary: primary,
  secondary: secondary,
  danger: danger,
  warning: warning,
  success: success,
  disabled: disabled
};
var quickVariants = _objectSpread(_objectSpread({}, heading), paragraph);
var link = {
  states: {
    focus: {
      outline: {
        width: focusOutlineWidth,
        color: focus,
        style: 'dashed',
        type: 'outline',
        offset: '2px'
      }
    }
  }
};

export { colors, link, quickVariants, typography };
